import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function AllDriversBusy({ rideBookingLogicData }) {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 6,
            }}
        >
            <Typography
                variant="h3"
                sx={{
                    color: '#000000',
                    backgroundColor: 'rgba(200, 76, 60, 1)',
                    borderRadius: 3,
                    paddingLeft: 1.5,
                    paddingRight: 1.5,
                    paddingTop: 1.0,
                    paddingBottom: 1.0,
                    fontSize: 34,
                    fontWeight: '900',
                }}
            >
                ALL DRIVERS BUSY
            </Typography>

            <Typography
                variant="h3"
                sx={{
                    marginTop: 2,
                    fontSize: 18,
                    color: 'white',
                }}
            >
                Please try again in a few minutes.
            </Typography>
        </Box>
    );
}
